var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1559_6330)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.0501 23.1753C47.9807 23.0234 46.3382 19.3765 42.7101 15.7484C37.8557 10.9015 31.7376 8.33838 24.9876 8.33838C18.2376 8.33838 12.1194 10.9015 7.27068 15.7484C3.64255 19.3765 2.00005 23.0234 1.92505 23.1753C1.79803 23.4632 1.73242 23.7746 1.73242 24.0893C1.73242 24.4041 1.79803 24.7154 1.92505 25.0034C1.99443 25.1571 3.63693 28.8021 7.26693 32.4303C12.1194 37.2771 18.2376 39.8384 24.9876 39.8384C31.7376 39.8384 37.8557 37.2771 42.7026 32.4303C46.3326 28.8021 47.9751 25.1571 48.0444 25.0034C48.1723 24.7158 48.2389 24.4047 48.2399 24.0899C48.2408 23.7751 48.1762 23.4636 48.0501 23.1753ZM39.4138 29.3628C35.3882 33.3265 30.5357 35.3384 24.9876 35.3384C19.4394 35.3384 14.5869 33.3265 10.5669 29.3609C8.98507 27.7957 7.62438 26.0218 6.52255 24.0884C7.6247 22.1557 8.98537 20.3825 10.5669 18.8178C14.5888 14.8503 19.4394 12.8384 24.9876 12.8384C30.5357 12.8384 35.3863 14.8503 39.4082 18.8178C40.9899 20.3824 42.3506 22.1556 43.4526 24.0884C42.3505 26.0217 40.9899 27.7955 39.4082 29.3609L39.4138 29.3628ZM24.9876 15.8384C23.3559 15.8384 21.7608 16.3222 20.4041 17.2288C19.0474 18.1353 17.99 19.4237 17.3655 20.9312C16.7411 22.4387 16.5777 24.0975 16.8961 25.6979C17.2144 27.2982 18.0001 28.7682 19.1539 29.922C20.3077 31.0758 21.7777 31.8615 23.3781 32.1799C24.9784 32.4982 26.6372 32.3348 28.1447 31.7104C29.6522 31.086 30.9407 30.0285 31.8472 28.6718C32.7537 27.3151 33.2376 25.7201 33.2376 24.0884C33.2351 21.9011 32.3651 19.8041 30.8184 18.2575C29.2718 16.7109 27.1748 15.8409 24.9876 15.8384ZM24.9876 27.8384C24.2459 27.8384 23.5208 27.6184 22.9042 27.2064C22.2875 26.7943 21.8068 26.2087 21.523 25.5234C21.2392 24.8382 21.1649 24.0842 21.3096 23.3568C21.4543 22.6294 21.8115 21.9612 22.3359 21.4367C22.8603 20.9123 23.5285 20.5551 24.256 20.4104C24.9834 20.2657 25.7374 20.34 26.4226 20.6238C27.1078 20.9077 27.6935 21.3883 28.1056 22.005C28.5176 22.6217 28.7376 23.3467 28.7376 24.0884C28.7376 25.0829 28.3425 26.0368 27.6392 26.74C26.9359 27.4433 25.9821 27.8384 24.9876 27.8384Z",
    fill: "url(#paint0_linear_1559_6330)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1559_6330",
    x1: 1.73242,
    y1: 39.8384,
    x2: 52.013,
    y2: 31.7269,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1559_6330"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0.988281 0.0883789)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/Eye.02c37039742c6c0e931b9361008bb242.svg";
export { ForwardRef as ReactComponent };